import {
    TournamentMatchListActions,
    TournamentMatchListSetActiveMarketGroupAction,
    TournamentMatchListSetFilterDataAction,
    TournamentMatchListStoreModel,
} from './tournament-match-list.constants';
import { ACTION_CORE_API_SUB_DUMP, ACTION_CORE_API_SUB_UPDATE, AppAction } from '@om-fe/store';
import { filterItemsFromRecords, filterItemsSelectorFromRecords } from '../../utils/filter-items-from-records';
import applyUpdatesForMatchList from '../../utils/apply-updates-for-match-list';
import { getTournamentMatchListSliceName, getTournamentGroupsMatchListSliceName } from './tournament-match-list.utils';
import { AggregatorOneOfTypeModel } from '@om-fe/models';
import { UpdateAction } from '@om-fe/api';
import { isBrowser } from '@om-fe/utils';

const initialState: TournamentMatchListStoreModel = {
    fetchedFromBrowser: isBrowser(),
    ready: false,
    discipline: undefined,
    filteredEventInfos: {},
    filteredMainMarketsList: [],
    filteredMainMarkets: {},
    filteredMarketGroupsOverviewList: [],
    filteredMarketGroupsOverview: {},
    filteredMarketAndOutcomeRelation: {},
    filteredOutcomes: {},
    filteredBettingOffers: {},
    filteredMatchesWithEvents: {},
    filteredEventStatistics: [],
    filteredMatchesIds: [],
    marketsWithOutcomesAndBettingOffers: {},
    filteredStreamingProviderEventRelation: {},
    filteredMainOutrightsMarketsList: [],
    activeMarketGroup: {},
    extraParam: undefined,
};

export const tournamentMatchListReducerCreator = (instanceId: string) => (
    state: TournamentMatchListStoreModel = initialState,
    action: AppAction,
): TournamentMatchListStoreModel => {
    const slice: string = getTournamentMatchListSliceName(instanceId);

    const { meta } = action;

    if (!meta || meta.slice !== slice) {
        return state;
    }

    switch (action.type) {
        case TournamentMatchListActions.SetFilterData: {
            const { payload } = action as TournamentMatchListSetFilterDataAction;

            return {
                ...state,
                tournamentId: payload.tournamentId,
                liveStatus: payload.liveStatus,
                isDefault: payload.isDefault,
                mainMarketsLimit: payload.mainMarketsLimit,
                isAuthenForTopic: payload.isAuthenForTopic,
            };
        }
        case ACTION_CORE_API_SUB_DUMP: {
            const { payload } = action as UpdateAction<AggregatorOneOfTypeModel>;

            const records: AggregatorOneOfTypeModel[] = payload.records;

            return {
                ...state,
                fetchedFromBrowser: isBrowser(),
                ready: true,
                ...filterItemsFromRecords(records),
            };
        }
        case ACTION_CORE_API_SUB_UPDATE: {
            const { payload } = action as UpdateAction<AggregatorOneOfTypeModel>;

            return {
                ...state,
                ...applyUpdatesForMatchList(payload, state),
            };
        }
        default:
            return state;
    }
};

export const tournamentGroupsMatchListReducerCreator = (instanceId: string) => (
    state: TournamentMatchListStoreModel = initialState,
    action: AppAction,
): TournamentMatchListStoreModel => {
    const slice: string = getTournamentGroupsMatchListSliceName(instanceId);

    const { meta } = action;

    if (!meta || meta.slice !== slice) {
        return state;
    }

    switch (action.type) {
        case TournamentMatchListActions.SetFilterData: {
            const { payload } = action as TournamentMatchListSetFilterDataAction;

            return {
                ...state,
                tournamentId: payload.tournamentId,
                liveStatus: payload.liveStatus,
                isDefault: payload.isDefault,
                mainMarketsLimit: payload.mainMarketsLimit,
                isAuthenForTopic: payload.isAuthenForTopic,
            };
        }
        case ACTION_CORE_API_SUB_DUMP: {
            const { payload } = action as UpdateAction<AggregatorOneOfTypeModel>;

            const records: AggregatorOneOfTypeModel[] = payload.records;

            return {
                ...state,
                fetchedFromBrowser: isBrowser(),
                ready: true,
                ...filterItemsSelectorFromRecords(records),
            };
        }
        case ACTION_CORE_API_SUB_UPDATE: {
            const { payload } = action as UpdateAction<AggregatorOneOfTypeModel>;

            return {
                ...state,
                ...applyUpdatesForMatchList(payload, state),
            };
        }
        default:
            return state;
    }
};

export const tournamentGroupsOverviewMatchListReducerCreator = (instanceId: string) => (
    state: TournamentMatchListStoreModel = initialState,
    action: AppAction,
): TournamentMatchListStoreModel => {
    const slice: string = getTournamentMatchListSliceName(instanceId);

    const { meta } = action;

    if (!meta || meta.slice !== slice) {
        return state;
    }

    switch (action.type) {
        case TournamentMatchListActions.SetFilterData: {
            const { payload } = action as TournamentMatchListSetFilterDataAction;

            return {
                ...state,
                tournamentId: payload.tournamentId,
                liveStatus: payload.liveStatus,
                isDefault: payload.isDefault,
                mainMarketsLimit: payload.mainMarketsLimit,
                marketGroupsOverviewIds: payload.marketGroupsOverviewIds,
                extraParam: payload.extraParam,
                isAuthenForTopic: payload.isAuthenForTopic,
            };
        }
        case TournamentMatchListActions.SetActiveMarketGroup: {
            const { payload } = action as TournamentMatchListSetActiveMarketGroupAction;

            return {
                ...state,
                activeMarketGroup: payload.activeMarketGroup,
            };
        }
        case ACTION_CORE_API_SUB_DUMP: {
            const { payload } = action as UpdateAction<AggregatorOneOfTypeModel>;

            const records: AggregatorOneOfTypeModel[] = payload.records;

            return {
                ...state,
                fetchedFromBrowser: isBrowser(),
                ready: true,
                ...filterItemsSelectorFromRecords(records),
            };
        }
        case ACTION_CORE_API_SUB_UPDATE: {
            const { payload } = action as UpdateAction<AggregatorOneOfTypeModel>;

            return {
                ...state,
                ...applyUpdatesForMatchList(payload, state),
            };
        }
        default:
            return state;
    }
};